import { render, staticRenderFns } from "./ph-big-star.vue?vue&type=template&id=0f420f35"
import script from "./ph-big-star.vue?vue&type=script&lang=js"
export * from "./ph-big-star.vue?vue&type=script&lang=js"
import style0 from "./ph-big-star.vue?vue&type=style&index=0&id=0f420f35&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports